<template>
  <div class="logo-main-version-content" id="identidade-visual-logo-versao-principal" data-search-anchor>
    <div class="title-wrapper">
      <h1 class="logo-main-title-span">{{ logoMainVersionTitleSpan }}</h1>
      <h1 class="logo-main-title">{{ logoMainVersionTitle }}</h1>
    </div>

    <div>
      <div
        class="logo-main-card-item"
        :style="{ backgroundImage: `url(${logoMainVersionImageSrc})` }"
      ></div>
      <div class="button-logo-main-wrapper">
        <RedirectOneDriveButton
          :linkUrl="onedriveUrl"
          buttonText="Baixar logos"          
        />      
      </div>      
    </div>

    <div class="description-wrapper">      
        <p class="logo-main-description">{{ logoMainVersionDescription }}</p>
        <p class="logo-main-description">{{ logoMainVersionDescription1 }}</p>
        <p class="logo-main-description">{{ logoMainVersionDescription2 }}</p>       

      <div class="icon-wrapper-first">
        <IconCheck />
        <p class="logo-main-description-icon">{{ logoMainVersionDescription3 }}</p>
      </div>
      <div class="icon-wrapper">
        <IconCancel />
        <p class="logo-main-description-icon">{{ logoMainVersionDescription4 }}</p>
      </div>
    </div>
  </div>   
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import IconCheck from '@/assets/icons/IconCheck.vue'
import IconCancel from '@/assets/icons/IconCancel.vue'

@Component({
  components: {
    IconCheck,
    IconCancel    
  }
})
export default class LogoMainVersionSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  onedriveUrl = 'https://tvglobocorp.sharepoint.com/sites/intranetconexao/DocumentosMarca/Logo'

  get logoMainVersionTitleSpan(): string {
    return this.getElementTitle(2, 0)
  }

  get logoMainVersionTitle(): string {
    return this.getElementText(2, 0)
  }

  get logoMainVersionDescription(): string {
    return this.getElementText(2, 1)
  }

  get logoMainVersionDescription1(): string {
    return this.getElementText(2, 2)
  }

  get logoMainVersionDescription2(): string {
    return this.getElementText(2, 3)
  }

  get logoMainVersionImageSrc(): string {
    return this.getElementMedia(2, 6)
  }

  get logoMainVersionDescription3(): string {
    return this.getElementText(2, 4)
  }

  get logoMainVersionDescription4(): string {
    return this.getElementText(2, 5)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-main-version-content {
  display: grid;
  width: 100%;
  grid-template-columns: 50% 50%;
  grid-template-rows: 4rem;     
  max-width: 1032px;
}

.title-wrapper {
  display: flex;
  align-items: center;
  height: 51px;
  width: 383px;  
}

.teste{
  padding-top: 1rem;
}

.logo-main-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px; 
  color: #b3b3b3;
}

.logo-main-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-wrapper {  
  position: relative;  
}

.logo-main-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  white-space: pre-line;

  width: 430px;
}

.icon-wrapper-first {
  display: flex;
  align-items: center;
  margin-top: 1.62rem;
}

.icon-wrapper {
  display: flex;
  align-items: center;
}

.logo-main-description-icon {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  width: 378px;
  padding-left: 7px;
}

.logo-main-card-item {
  position: relative;
  top: 4rem;    

  width: 516px;
  height: 148px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.button-logo-main-wrapper {
  position: relative;
  top: 6.43rem;
}
</style>
